import {
  IonButton, IonCol, IonContent, IonGrid, IonIcon, IonPage, IonRow,
} from '@ionic/react';
import {
  arrowRedoSharp, chevronDownSharp,
} from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// swiper bundle styles
import 'swiper/swiper-bundle.min.css';
// swiper core styles
import 'swiper/swiper.min.css';
import DecisionPointCard from '../../components/Cards/DecisionPointsCard';
// import TopicProcessGoals from '../../assets/image-gradient_01.svg';
import TreeChart from '../../components/D3/Tree';
import ListGrid from '../../components/ListGrid/ListGrid';
import SearchBar from '../../components/SearchBar';
import { DecisionPoints } from '../../models/DecisionPoints';
import { Folder } from '../../models/Folder';
import { FolderItem } from '../../models/FolderItem';
import DAService from '../../services/DAService.service';
import './ProcessGoalsPage.scss';
import ListModal from '../../components/Modal/ListModal';
import LocalStorage from '../../utils/LocalStorage';
import ShareModal from '../../components/ShareModal';
import StyleHelper from '../../utils/StyleHelper';
import TextHelper from '../../utils/TextHelper';
import { InlineGuidance } from '../../models/InlineGuidance';
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

interface IWithChildren {
  children?: any[],
  __rd3t?: any
}
interface StateType {
  itemId: {}
}

// Since the children key set from onClick of tree only applies here(for now)
type DecisionWithChildren = DecisionPoints & IWithChildren;
type FolderWithChildren = FolderItem & IWithChildren;

export default function ProcessGoalsPage(props: {
  screenSize: number;
}) {
  const [processGoalFull, setProcessGoalFull] = useState<DecisionWithChildren | FolderWithChildren>();
  const [processGoal, setProcessGoal] = useState<DecisionWithChildren | FolderWithChildren>();
  const [phaseName, setPhaseName] = useState<string>();
  const [toExpandId, setToExpandId] = useState<any>();
  const [parentId, setParentId] = useState<any>();
  const [hasTopic, setHasTopic] = useState(false);
  const params: { itemId: string } = useParams();
  const { screenSize } = props;
  const [paddingStyle, setPaddingStyle] = useState('');
  const [slidesPerView, setSlidesPerView] = useState<number>(1);
  const [initialDepth, setInitialDepth] = useState(0);
  const [zoomLevel, setZoomLevel] = useState(0);
  const location = useLocation<StateType>();
  const { state } = location;
  const [showModal, setShowModal] = useState(false);
  const [shareLink, setShareLink] = useState('');
  const [shareOpen, setShareOpen] = useState(false);
  const [addResources, setAddResources] = useState<InlineGuidance[] | undefined>([]);
  let trueIndex = 0;

  useEffect(() => {
    if (state?.itemId) {
      setTimeout(() => {
        document.getElementById(`onNodeClick-${state?.itemId}`)?.click();
      }, 500);
    }

    return () => {
      window.removeEventListener('click', () => { });
    };
  }, [state]);

  useEffect(() => {
    const queryParams = location.search.split('&');
    const decisionItem = queryParams.find((q: string) => q.includes('decision'));

    if (decisionItem) {
      const decId = decisionItem?.split('=')[1];

      setTimeout(() => {
        document.getElementById(`onNodeClick-${decId}`)?.click();
      }, 800);
      setTimeout(() => {
        window.removeEventListener('click', () => { });
      }, 1000);
    }
  }, []);

  useEffect(() => {
    DAService.getFolders().map((folder: Folder) => {
      // eslint-disable-next-line
      folder.folderItems && folder.folderItems.map((topic) => {
        if (topic.folderItems) {
          topic.folderItems.map((goal: DecisionPoints) => {
            if (goal.itemId === params.itemId) {
              setPhaseName(topic.name);
              setHasTopic(true);
              setProcessGoal(goal);
              setProcessGoalFull(goal);
            }
            return true;
          });
        } else if (topic.itemId === params.itemId) {
          setPhaseName(topic.name);
          setHasTopic(false);
          setProcessGoal(topic);
          setProcessGoalFull(topic);
        }
      });
      return true;
    });
  }, [params.itemId, location, phaseName]);

  // resets all the state when react router changes
  useEffect(() => {
    setInitialDepth(0);
    setZoomLevel(0);
  }, [location]);

  useEffect(() => {
    setPaddingStyle('padding-xs');

    // handle slidesPerView
    if (screenSize < 500) {
      setSlidesPerView(1.5);
    } else if (screenSize < 550) {
      setSlidesPerView(2);
    } else if (screenSize < 600) {
      setSlidesPerView(2.4);
    } else if (screenSize < 700) {
      setSlidesPerView(2.8);
    } else if (screenSize < 1000) {
      setSlidesPerView(3);
    } else if (screenSize < 1200) {
      setSlidesPerView(4);
    } else if (screenSize < 1400) {
      setSlidesPerView(5);
    } else {
      setSlidesPerView(6);
    }

    setInitialDepth(1);
    setZoomLevel(0.8);
  }, [screenSize, initialDepth, zoomLevel]);

  useEffect(() => {
    // To reset to original date if the root is selected back
    if ((processGoal && processGoalFull) && processGoal?.itemId === processGoalFull?.itemId) {
      setProcessGoal(processGoalFull);
      window.history.replaceState(null, '', `/goals/${processGoalFull?.itemId}`);

      // To reset to original if current is collapsed
    } else if (processGoal?.__rd3t.depth && !processGoal?.__rd3t.collapsed) {
      setProcessGoal(processGoalFull);
      window.history.replaceState(null, '', `/goals/${processGoalFull?.itemId}`);
    }

    if (processGoal?.__rd3t?.depth === 1) {
      window.history.replaceState(null, '', `/goals/${processGoalFull?.itemId}?decision=${processGoal.itemId}`);
    }

    setShareLink(window.location.href);
    setAddResources(processGoal?.inlineGuidance?.filter((l: any) => TextHelper.isURL(l?.urlString)));
  }, [processGoal]);

  const showModalList = () => {
    setShowModal(true);
    setParentId(processGoalFull?.itemId);
    const topicPath: any[] = DAService.getPath(DAService.getData(), params.itemId, true) || [];
    const topicId = topicPath[topicPath.length - (hasTopic ? 2 : 1)].itemId;

    let index = 0;

    DAService.getFolders().map((folder: Folder) => {
      folder?.folderItems?.map((topic) => {
        trueIndex += 1;
        if (topicId === topic.itemId) {
          index = trueIndex;
        }
        return true;
      });
      return true;
    });

    LocalStorage.set('topicIndex', index);

    if (processGoal?.__rd3t) {
      setToExpandId(processGoal?.itemId);
    } else {
      setToExpandId(null);
    }
  };

  return (
    <IonPage>
      <IonContent>
        <IonGrid className="process-goal-page" style={{ padding: '26px 16px 0px 16px' }}>
          <SearchBar hasNavigation data={processGoal} />
          <IonRow style={{ textAlign: 'center', paddingTop: '8px' }}>
            <ListModal toExpandId={toExpandId} parentId={parentId} showModal={showModal} setShowModal={setShowModal} />
            <IonCol size="6" className="process-goal-container" style={{ justifyContent: 'start' }}>
              <IonButton fill="clear" className="process-goal-sub-btn phase-text" onClick={showModalList}>
                {`${phaseName} Phase`}
                <IonIcon src={chevronDownSharp} style={{ marginLeft: '4px', color: '#FFFFFF', fontSize: '16px' }} />
              </IonButton>
            </IonCol>
            <IonCol size="6" className="process-goal-container" style={{ justifyContent: 'end' }}>
              {/* <span className="process-goal-sub-btn distribute-text" style={{ marginRight: '5px' }}>
                <IonIcon src={exitOutline} style={{ marginRight: '4px', color: '#FFFFFF', fontSize: '16px', fontWeight: '900' }} />
                Export
              </span> */}
              <IonButton fill="clear" className="process-goal-sub-btn distribute-text" onClick={(): void => { setShareOpen(true); }}>
                <IonIcon src={arrowRedoSharp} style={{ marginRight: '4px', color: '#FFFFFF', fontSize: '16px' }} />
                Share
              </IonButton>
              {/* </CopyToClipboard> */}
              <ShareModal open={shareOpen} setOpen={setShareOpen} shareLink={shareLink} />
            </IonCol>
          </IonRow>
        </IonGrid>
        <div style={{ backgroundColor: '#F7F7F7' }}>
          <TreeChart
            zoomlevel={zoomLevel}
            processGoal={processGoalFull}
            screenSize={screenSize}
            initialDepth={initialDepth}
            setProcessGoal={setProcessGoal}
          />
        </div>
        <div className="breadcrumbs-wrapper">
          <div className="crumbs-item">
            <div>
              <div className="process-goal-section process-goal-name-color">
                {processGoalFull && processGoalFull.name.toString().replace('<br>', ' ')}
              </div>
              <div className="process-goal-section process-goal-default-color">
                Process Goal
              </div>
            </div>
          </div>
          {
            processGoal?.itemId !== processGoalFull?.itemId
            && (
              <>
                <div>
                  {'>>'}
                </div>
                <div className="crumbs-item">
                  <div>
                    <div className="process-goal-section process-goal-name-color active">
                      {processGoal && processGoal.name.toString().replace('<br>', ' ')}
                    </div>
                    <div className="process-goal-section process-goal-default-color active">
                      {processGoal?.__rd3t?.depth === 0 ? 'Process Goal' : 'Decision Point'}
                    </div>
                  </div>
                </div>
              </>
            )
          }
        </div>
        <div style={{ padding: '16px' }}>
          <div
            style={{
              fontSize: '24px',
              lineHeight: '30px',
              letterSpacing: '1px',
              fontFamily: 'AgrandirRegular',
              color: '#1F1F1F',
              padding: '16px 0px',
            }}
          >
            {processGoal?.name.replace('<br>', ' ')}
          </div>
          {/* eslint-disable-next-line  */}
          <div dangerouslySetInnerHTML={{ __html: processGoal?.description || '' }} />
        </div>

        {!processGoal?.__rd3t || (processGoal?.__rd3t?.depth === 1 && !processGoal?.__rd3t.collapsed)
          ? (
            <div className={paddingStyle} style={{ background: '#501AA6' }}>
              <div className="section-label">
                Decision Points
              </div>

              <Swiper
                slidesPerView={slidesPerView}
                observeParents
                observer
                initialSlide={0}
                navigation={{
                  nextEl: '.next',
                }}
                loop
              >
                {
                  (processGoal?.decisionPoints)?.map((decision: DecisionPoints, index: number) => (
                    <SwiperSlide key={`slider-${decision.itemId}`}>
                      <DecisionPointCard nodeDatum={decision} gradient={StyleHelper.getGradient(index)} />
                    </SwiperSlide>
                  ))
                }
              </Swiper>
              {/* <div className="view-all-process-goals">
                {`View All ${'Decision Points'}`}
                <div className="view-all-circle">
                  <span className="view-all-arrow next">
                    <IonIcon src={arrowForwardOutline} />
                  </span>
                </div>
              </div> */}
            </div>
          )
          : (
            <div className={paddingStyle}>
              <div className="section-label" style={{ color: '#212121', paddingBottom: '16px' }}>
                Options
              </div>
              {processGoal?.children?.map((item, index) => (
                <button
                  key={item.itemId}
                  type="button"
                  onClick={(() => document.getElementById(`onNodeClick-${item.itemId}`)?.click())}
                  style={{ background: 'transparent', width: '100%', padding: '0px' }}
                >
                  <ListGrid
                    item={item}
                    arrayLength={processGoal?.children!.length}
                    index={index}
                    itemType="default"
                  />
                </button>
              ))}
            </div>
          )}
        {addResources?.length
          ? (
            <div style={{ padding: '16px' }}>
              <div className="additional-resources">
                Additional Resources
              </div>
              {addResources.map((url: any, index: number) => (
                <a
                  href={url?.urlString}
                  target="_blank"
                  rel="noreferrer"
                  key={`url-${processGoal?.itemId}-${Math.random()}`}
                  style={{ textDecoration: 'none' }}
                >
                  <ListGrid
                    item={url}
                    arrayLength={addResources.length}
                    index={index}
                    itemType="process-goal-additional-resources"
                  />
                </a>
              ))}
            </div>
          ) : null}
      </IonContent>
    </IonPage>
  );
}
